var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"sm":"12","xl":"8"}},[(_vm.title)?_c('h1',{staticClass:"app-title mb-3"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }